import { createBrowserHistory } from 'history';

// TODO: TS4 - For some reason the "setup variable" for ROUTER_BASE_URL was not working
// in the test environment for CRA. I've hardcoded the value as it does not ever change.
// Verified this build and runs tests in Azure, double-check if this okay.
export const history = createBrowserHistory({ basename: '/app' });

export default history;
